import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const switchStylesDefaultVariants = {
  "size": "md"
}
const switchStylesCompoundVariants = []

const switchStylesSlotNames = [
  [
    "root",
    "Switch__root"
  ],
  [
    "wrapper",
    "Switch__wrapper"
  ],
  [
    "switch",
    "Switch__switch"
  ],
  [
    "handle",
    "Switch__handle"
  ],
  [
    "offLabel",
    "Switch__offLabel"
  ],
  [
    "onLabel",
    "Switch__onLabel"
  ]
]
const switchStylesSlotFns = /* @__PURE__ */ switchStylesSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, switchStylesDefaultVariants, getSlotCompoundVariant(switchStylesCompoundVariants, slotName))])

const switchStylesFn = memo((props = {}) => {
  return Object.fromEntries(switchStylesSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const switchStylesVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...switchStylesDefaultVariants, ...compact(variants) })

export const switchStyles = /* @__PURE__ */ Object.assign(switchStylesFn, {
  __recipe__: false,
  __name__: 'switchStyles',
  raw: (props) => props,
  variantKeys: switchStylesVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, switchStylesVariantKeys)
  },
  getVariantProps
})